import React from "react";
import { MdClose } from "react-icons/md";

const Modal = ({ isOpen, onClose, item, onSave }) => {
  if (!isOpen) return null; // If modal is closed, don't render anything

  const handleSave = () => {
    onSave(item); // Handle save logic
    onClose(); // Close the modal after saving
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-1/2 p-4">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold">Edit Website Page</h2>
          <button onClick={onClose}>
            <MdClose size={24} />
          </button>
        </div>
        <div className="mt-4">
          <label className="block text-sm text-gray-600">Page Name</label>
          <input
            type="text"
            className="w-full p-2 mt-2 border border-gray-300 rounded-md"
            value={item.name}
            onChange={(e) => (item.name = e.target.value)} // Update the name as user types
          />
        </div>
        {/* You can add more fields here as needed */}
        <div className="mt-4 text-right">
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white p-2 rounded-md"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
